var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.confirm)?_c('div',[_c('Confirm',{attrs:{"message":_vm.confirm.message,"textConfirm":_vm.confirm.textConfirm,"textCancel":_vm.confirm.textCancel},on:{"confirm":function($event){return _vm.confirmed()},"cancel":function($event){return _vm.cancelled()}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }